import { Link } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import MainContainer from "components/common/MainContainer";
import PageHeader from "components/common/PageHeader";
import { usAdminAppRoutes } from "../../route-definitions";

const linkConfigs = [
  {
    key: "endUsers",
    path: usAdminAppRoutes.endUsers,
    intlId: "usAdmin.endUser",
  },
  { key: "vendors", path: usAdminAppRoutes.vendors, intlId: "usAdmin.vendor" },
  {
    key: "distributors",
    path: usAdminAppRoutes.distributors,
    intlId: "usAdmin.distributor",
  },
  {
    key: "territoryManagers",
    path: usAdminAppRoutes.territoryManagers,
    intlId: "usAdmin.territoryManager",
  },
  {
    key: "industrySpecialists",
    path: usAdminAppRoutes.industrySpecialists,
    intlId: "usAdmin.industrySpecialist",
  },
];

const AdminApp = () => {
  const intl = useIntl();

  const appLinks = linkConfigs.map(({ key, path, intlId }) => (
    <Link key={key} to={path} className="usadmin-button">
      {intl.formatMessage({ id: intlId })}
    </Link>
  ));

  return (
    <MainContainer
      pageTitle={
        <PageHeader
          className="page-layout__heading-title"
          header={<FormattedMessage id="usAdmin.usAdminApp" />}
        />
      }
    >
      <div className="usadmin-container">{appLinks}</div>
    </MainContainer>
  );
};

export default AdminApp;
